<template>
  <div>
    <form @submit.prevent="clickHandler">
      <div class="columns">
        <div class="column">
          <b-field>
            <b-input v-model="search" icon="magnify" size="is-medium" placeholder="Cari..."></b-input>
          </b-field>
        </div>

        <div class="column is-narrow">
          <div class="columns is-mobile">
            <div class="column is-narrow">
              <button type="submit" class="button is-primary is-medium tooltip is-tooltip-right" data-tooltip="Cari" :disabled="loading" :class="{'is-loading': loading}">
                <span class="icon"><i class="fas fa-search"></i></span>
                <span>Cari</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    dataProvider: {
      type: Object,
      required: true
    },
    clickHandler: {
      type: Function,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    },
    searchCriteria: {
      type: String,
      default: 'name,code,app_id,secret_id,url'
    },
    fields: {
      type: Array,
      default: () => ['periode']
    },
    sortOptions: {
      type: Array,
      default: () => [
        { criteria: 'name', order: 'asc', value: 'name__asc', text: 'A - Z' },
        { criteria: 'name', order: 'desc', value: 'name__desc', text: 'Z - A' },
        { criteria: 'created_at', order: 'desc', value: 'created_at__desc', text: 'Terbaru' },
        { criteria: 'created_at', order: 'asc', value: 'created_at__asc', text: 'Terlama' },
        { criteria: 'used', order: 'desc', value: 'used__desc', text: 'Penyimpanan Terbesar' },
        { criteria: 'used', order: 'asc', value: 'used__asc', text: 'Penyimpanan Terkecil' },
        { criteria: 'latest_post', order: 'desc', value: 'latest_post__desc', text: 'Postingan Terbaru' },
        { criteria: 'latest_post', order: 'asc', value: 'latest_post__asc', text: 'Postingan Terlama' },
        { criteria: 'conferences_used_count', order: 'desc', value: 'conferences_used_count__desc', text: 'Conference Terbanyak Berlangsung' },
        { criteria: 'learning_materials_count', order: 'desc', value: 'learning_materials_count__desc', text: 'Materi Terbanyak' },
        { criteria: 'posts_count', order: 'desc', value: 'posts_count__desc', text: 'Postingan Terbanyak' },
        { criteria: 'classes_count', order: 'desc', value: 'classes_count__desc', text: 'Kelas Terbanyak' },
      ]
    }
  },

  computed: {
    search: {
      get() {
        const vm = this;
        const search = collect(this.dataProvider.criterion).where('criteria', vm.search_criteria).first();

        return !this.isEmpty(search) ? search.value : '';
      },
      set(val) {
        const vm = this;
        this.dataProvider['criterion'] = collect(this.dataProvider.criterion).map((c) => {
          if (c.criteria == vm.search_criteria) {
            c['value'] = val;
          }

          return c;
        }).toArray();
      }
    },
    sort: {
      get() {
        const vm = this;
        const sort = collect(this.dataProvider.sort).first();
        let option = null;

        if (!vm.isEmpty(sort)) {
          option = collect(this.sort_options).where('criteria', '==', sort.criteria).where('order', '==', sort.order).first();
        }

        return !this.isEmpty(option) ? option.value : '';
      },
      set(val) {
        const vm = this;
        let option = collect(this.sort_options).where('value', '==', val).first();

        if (!this.isEmpty(option)) {
          this.dataProvider['sort'] = [{
            criteria: option.criteria,
            order: option.order,
            no_table: true
          }]
        }
      }
    },
    periode: {
      get() {
        const vm = this;
        const periode = collect(this.dataProvider.criterion).where('criteria', 'periode').first();

        return !this.isEmpty(periode) ? periode.value : '';
      },
      set(val) {
        const vm = this;
        this.dataProvider['criterion'] = collect(this.dataProvider.criterion).map((c) => {
          if (c.criteria == 'periode') {
            c['value'] = val;
          }

          return c;
        }).toArray();
      }
    },
  },

  data() {
    return {
      open: false,
      sort_criteria: 'name',
      sort_options: _.cloneDeep(this.sortOptions),
      search_criteria: _.clone(this.searchCriteria)
    }
  }
}
</script>
